<template>
  <div :class="bem.b()">
    <ll-tooltip placement="top">
      <template #title>
        <div v-if="loading" :class="[bem.b('tooltip-title-succeed')]">
          <ll-icon
            v-if="iconName"
            :icon-name="iconName || 'icon-succeed'"
            :size="14"
            :color="iconColor || '#fff'"
          />
          <span>{{ props.copySucceed }}</span>
        </div>
        <div v-else>{{ props.clickText }}</div>
      </template>
      <div :class="[bem.e('content')]" @click="handleCopy(String(value))">
        <slot name="value">
          {{ value }}
        </slot>
      </div>
    </ll-tooltip>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { ref } from 'vue'
import { copyTextProps } from './copy-text'

defineOptions({ name: 'LlCopyText' })

const bem = createNamespace('copy-text')

const props = defineProps(copyTextProps)
const loading = ref<boolean>(false)

const handleCopyText = (title: string) => {
  const textarea = document.createElement('textarea')
  textarea.value = title
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('Copy')
  document.body.removeChild(textarea)
}

const handleCopy = (value: string) => {
  try {
    loading.value = true
    handleCopyText(value)
    setTimeout(() => {
      loading.value = false
    }, 3000)
  } catch (error) {
    loading.value = false
  }
}
</script>
